<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="rounded-md bg-blue-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <!-- Heroicon name: solid/exclamation -->
        <svg
          class="h-5 w-5 text-yellow-400"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          />
        </svg>
      </div>
      <div class="ml-3">
        <!-- <h3 class="text-sm font-medium text-blue-800">Attention needed</h3> -->
        <div class="text-sm text-blue-700">
          <p>
            {{ message }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="section mt-4">
        <div class="row">
            <div class="col-lg-2">
            </div>
            <div class="col-lg-8">
                <div class="card shadow p-3 " style="background-color: #e6ffe6;">
                    <div class="row">
                        <div class="col-2 d-flex">
                            <img src="/icons/tip.png" class="rounded float-left" style="width: 100%;" alt="">
                        </div>
                        <div class="col-10 my-auto">
                            {{ message }}
                        </div>           
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
            </div>
        </div>     
    </div> -->
</template>

<script>
export default {
  props: ["message"],
};
</script>